import { authoringReaders, catalogPartVisible, type AuthoringFacts } from './enchantment';
import { trapObjectOptions } from './trap';
import { trapMountPrefillDc } from '../traps/mount';
import { phpJsonInt } from '../compile/php-json-values';

/** The joined saved rows retain template order; the first visible part supplies its summary/DC. */
export function trapPanelOptions(facts: AuthoringFacts) {
    const read = authoringReaders(facts), seen = new Set<string>();
    const templates = facts.templates.flatMap(row => {
        const id = String(row.enchantment_template_id).toUpperCase();
        const ability = read.definition(String(row.enchantment_item_id));
        if (seen.has(id) || !ability || !catalogPartVisible(ability, facts, read)) return [];
        seen.add(id);
        const dice = phpJsonInt(read.layerValue(ability, 'dice')), die = phpJsonInt(read.layerValue(ability, 'die'));
        const nature = String(read.layerValue(ability, 'trap_classification') ?? 'mechanical').toLowerCase();
        const name = String(row.enchantment_template_name || read.name(ability) || id);
        const summary = `${dice > 0 ? `${dice}d${die}, ` : ''}${nature}`.trim();
        return [{ id, name, dc: trapMountPrefillDc(ability, read.layerValue), text: `${name} (${summary})` }];
    });
    const visible = { ...facts, candidates: facts.candidates.filter(row => {
        const definition = read.definition(String(row.item_id));
        return definition && catalogPartVisible(definition, facts, read);
    }) };
    return { templates, hosts: trapObjectOptions(visible) };
}
